var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-center double-spaced"},_vm._l((_vm.rrss),function(socialMedia){return _c('a',{staticClass:"rrss",attrs:{"href":socialMedia.link,"target":"_blank"}},[_c('i',{class:'fab ' + socialMedia.font_icon})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }